
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";
import ModalMixin from "./mixin";
import StockOrderHeader from "@/components/barcodeSystem/stockOrder/StockOrderHeader.vue";
import StockOrderItemTable from "@/components/barcodeSystem/stockOrder/StockOrderItemTable.vue";
import { StockOrderResource } from "@/models/api/barcodeSystem/stockOrders/get";
import notifications from "@/lib/notifications";

const stockOrderModuleState = getModule(StockOrderModule);

@Component({
  name: modals.stockOrderViewModal,
  components: {
    StockOrderHeader,
    StockOrderItemTable
  }
})
export default class StockOrderViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  itemsLoading: boolean = false;

  async load() {
    this.loadingComplete = false;
    this.show();
    await stockOrderModuleState.loadStockOrder(this.selectedItem.id);
    await stockOrderModuleState.loadStockOrderItems(this.selectedItem.id);
    this.loadingComplete = true;
  }

  get stockOrderItemCount() : number
  {
    if(stockOrderModuleState.currentStockOrderItems)
      return stockOrderModuleState.currentStockOrderItems.length;
    return 0
  }

  get currentStockOrder() : StockOrderResource
  {
    return stockOrderModuleState.currentStockOrder;
  }

  get requiresReceiving() : boolean
  {
    return this.currentStockOrder ? this.currentStockOrder.requiresReceiving : false;
  }

  
  async reloadOrder(){
    this.loadingComplete = false;
    try {
      await stockOrderModuleState.reloadStockOrder();
      await stockOrderModuleState.loadStockOrderItems(this.currentStockOrder.id);
    } catch (ex) {
      notifications.error("Failed to load stock order", "Failed to load stock order.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  async reloadStockOrderItems()
  {
    this.itemsLoading = true;
    try {
      await stockOrderModuleState.loadStockOrderItems(this.currentStockOrder.id);
    } catch(error) {
        notifications.error("Error reloading items", `Failed to reload order items.`, error);
    } finally {
      this.itemsLoading = false;
    }
  }

  reset() {
    this.loadingComplete = false;
  }
}
